import React from 'react'
import AcquireWebComponent from '../../framework/MaterialUI'
import { FullRow, Row, Col } from '../../framework/Grid/'
import { map } from 'lodash'

class TopAttributeListSection extends AcquireWebComponent {
	render() {
		const { title, subTitle, data } = this.props
		// const COLORS = ['#050505', '#0E222C', '#1C4456', '#2A6581', '#3888AB', '#609FBD', '#609FBD', '#87B7CD', '#AFCFDD', '#D6E7EF'];
		const AttributeTitle = { fontWeight: 'bold', lineHeight: '50px', background: '#f5f5f5' };
		const valueStyle = { lineHeight: '40px' };

		return (
			<div className="pb-20 bg-white" key={"key-" + title.replace(" ", "-")}>
				<FullRow className="no-padding-bottom no-margin-bottom" style={{paddingTop: '0px'}}>
					<div style={{
						fontSize: '24px',
						lineHeight: '70px',
						letterSpacing: '-0.015em'
					}}><strong>{title}</strong></div>
				</FullRow>
				<Row className="no-padding no-margin-bottom ml-20 mr-20 pb-5">
					<Col xs="3" sm="3" md="3" lg="3" style={AttributeTitle}><strong>Attribute</strong></Col>
					<Col xs="4" sm="4" md="4" lg="4" style={AttributeTitle}><strong>Value Pair</strong></Col>
					<Col xs="3" sm="3" md="3" lg="3" style={AttributeTitle}><strong>{subTitle}</strong></Col>
					<Col xs="2" sm="2" md="2" lg="2" style={AttributeTitle}>&nbsp;</Col>
				</Row>
				{ (!data || data.length === 0) ? <div style={{
					textAlign: 'center',
					color: '#ccc',
					fontSize: '24px',
					padding: '10px'
				}}>No Data.</div> : null }
				{
					map(data, function (obj, index) {
						return (
							<Row key={"top-visits-item-" + obj.name + "-" + obj.value} style={{fontWeight:300, borderBottom: '1px solid #E8EBEF'}}
							 className="gray-bottom-border no-padding no-margin-bottom ml-20 mr-20 pb-5 pt-5">
								<Col xs="3" sm="3" md="3" lg="3" style={valueStyle}>{obj.name}</Col>
								<Col xs="4" sm="4" md="4" lg="4" style={valueStyle}>{obj.value}</Col>
								<Col xs="3" sm="3" md="3" lg="3" style={valueStyle}>{(obj.visits * 100).toFixed(2) + '%'}</Col>
								<Col xs="2" sm="2" md="2" lg="2" style={{height: '40px', display: 'flex', alignItems: 'center'}}>
									<span style={{display:"inline-block", background: '#216E69', 
									width:(obj.visits * 100).toFixed(2) + '%', height: '22px'}}>&nbsp;</span></Col>
							</Row>
						)
					})
				}

			</div>
		)
	}
}

TopAttributeListSection.propTypes = {
	title: React.PropTypes.string.isRequired,
	data: React.PropTypes.array,
	subTitle: React.PropTypes.string.isRequired
}
export default TopAttributeListSection


// WEBPACK FOOTER //
// ./src/components/Insights/page/TopAttributeList.jsx